<template>
  <view>
    <view class="custom-view" v-if="messageData.type == 'TextAppendArgument'">
      <view class="content-view">{{ content }}</view>
      <view v-if="textArray.length" class="text-list">
        <view class="text-item" v-for="(text, index) in textArray" :key="index">
          {{ text.argumentDesc }}
        </view>
      </view>
    </view>
  </view>
</template>

<script>
export default {
  props: {
    messageItem: {
      type: Object,
    },
  },
  data() {
    return {}
  },
  computed: {
    // 消息内容
    messageData() {
      let data = ''
      if (this.messageItem?.c2cId) {
        data = this.messageItem?.payload?.MsgContent?.Data;
      } else {
        data = this.messageItem?.payload?.data;
      }
      return data ? JSON.parse(data) : {};
    },
    // 欢迎语
    content() {
      return this.messageData.content;
    },
    // 问题列表
    textArray() {
      return this.messageData.text
    }
  },
  methods: {}
}
</script>

<style scoped lang='scss'>
.custom-view {
  box-sizing: border-box;
  background: #dceafd;
  border-radius: 10px 0 10px 10px;
  .content-view {
    font-weight: bold;
    font-size: 30rpx;
    color: #000;
  }
  .text-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .text-item {
      margin-top: 10rpx;
      font-size: 28rpx;
      color: #2F7CFE;
    }
  }
}
</style>